import { Checkbox, FormControlLabel } from "@mui/material";
import { useEffect, useState } from "react";
import WorkLogReport from "../../models/WorkLogReport";
import WorkLogWeeklyService from "../../services/WorkLogWeeklyService";
import OpsDateUtils from "../../utils/OpsDateUtils";
import { SnackBarData } from "../../external/ensolvers-core-frontend-mui/types/SnackbarData";
import { sendSnackBarMessage } from "../../utils/SnackBarUtils";
import NotificationService from "../../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/NotificationService";

export const WorkLogWeeklyValidationCheckboxComponent = (props: {
  instance: WorkLogReport;
  date: Date;
  week: string;
  rows: WorkLogReport[];
  setRows: React.Dispatch<React.SetStateAction<WorkLogReport[]>>;
  canEdit: boolean;
}): JSX.Element => {
  const [buttonChecked, setButtonChecked] = useState<boolean>(props.instance.validated[props.week]);

  useEffect(() => setButtonChecked(props.instance.validated[props.week]), [props.instance]); // eslint-disable-line react-hooks/exhaustive-deps

  const updateValidatedWeekByRowExternalId = (assignationExternalId: string | undefined, week: string, validated: boolean) => {
    let newRows = props.rows;
    const index = newRows.findIndex((row) => row.assignationExternalId === assignationExternalId);

    if (index !== -1) {
      newRows[index].validated[week] = validated;
      props.setRows(newRows);
    }
  };

  const handleChange = async (checked: boolean) => {
    let shortWeekFirstDay = OpsDateUtils.getFirstDayOfWeekInMonth(props.date, parseInt(props.week) - 1);
    let date = OpsDateUtils.toUTC(shortWeekFirstDay);

    try {      
      //Optimistic update handler
      checkboxUpdateHandler(true, checked)

      // Try performing the approveWeek operation
      const response = await WorkLogWeeklyService.approveWeek({
        assignationExternalId: props.instance.assignationExternalId,
        shortWeekFirstDay: date,
        validated: checked,
      });

      //The report is locked by manager
      if (response.getContentOrThrowError().validated !== checked) {
        const snackData: SnackBarData = { text: "Cannot update. This report had been locked.", severity: "error" };
        sendSnackBarMessage(snackData);
        //Revert the optimistic update
        checkboxUpdateHandler(false, checked)
      }
    } catch (error: any) {
      // Error catching section (Missing worklogs, not enough permissions, etc)  
      if (error && error.apiResponse && error.apiResponse.message) {
        NotificationService.error(error.apiResponse.message);
      } else {
        NotificationService.error("Unexpected error at checking worklog");
      }
      //Revert the optimistic update
      checkboxUpdateHandler(false, checked)
    } 
  };

  const checkboxUpdateHandler = (success: boolean, checked: boolean) => {
    if (success) {
      //Optimistic update of the UI
      setButtonChecked(checked);
      updateValidatedWeekByRowExternalId(props.instance.assignationExternalId, props.week, checked);
    } else {
      //Revert changes in case of error or blocker
      setButtonChecked(!checked);
      updateValidatedWeekByRowExternalId(props.instance.assignationExternalId, props.week, !checked);
    }
  };

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={buttonChecked}
          onChange={(event) => handleChange(event.target.checked)}
          color="default"
          disabled={!props.canEdit}
        />
      }
      style={{ marginLeft: 0, marginRight: -8 }}
      label=""
    />
  );
};
